import { CallOutlined, PersonOutlined } from '@mui/icons-material';
import { Chip, Container, Typography } from '@mui/material';
import { useMemo } from 'react';
// @ts-ignore
import MicrospecDataTable from '../../../MicrospecDynamicUI/Components/DataTable/MicrospecFirestoreDataTable';
import { useMicrospecDynamicUIContext } from '../../../MicrospecDynamicUI/GlobalProvider';

const TYPE_CONFIG: Record<string, { label: string; color: 'primary' | 'secondary' | 'info' }> = {
  frontal: { label: 'حضوري', color: 'primary' },
  call: { label: 'اتصال', color: 'info' },
};

const STATUS_CONFIG: Record<string, { label: string; color: 'default' | 'success' | 'error' }> = {
  completed: { label: 'مكتمل', color: 'success' },
  cancelled: { label: 'ملغي', color: 'error' },
};

const PastAppointments = () => {
  const { cloudProvider } = useMicrospecDynamicUIContext();
  const userProfile = (cloudProvider as any).userProfile?.attributes;

  const columns = useMemo(() => [
    {
      field: 'client_name',
      headerName: 'العميل',
      minWidth: 160,
    },
    {
      field: 'type',
      headerName: 'نوع الموعد',
      minWidth: 120,
      render: (value: any) => {
        const cfg = TYPE_CONFIG[value] || { label: value, color: 'default' as const };
        return (
          <Chip
            component="span"
            size="small"
            icon={value === 'call' ? <CallOutlined fontSize="small" /> : <PersonOutlined fontSize="small" />}
            label={cfg.label}
            color={cfg.color}
            variant="outlined"
          />
        );
      },
    },
    {
      field: 'date_time',
      headerName: 'التاريخ والوقت',
      minWidth: 200,
      render: (value: any) => {
        if (!value) return '-';
        const date = new Date(value?.seconds ? value.seconds * 1000 : value);
        return (
          <Typography variant="body2">
            {date.toLocaleDateString('ar', { year: 'numeric', month: 'long', day: 'numeric' })}
            {' — '}
            {date.toLocaleTimeString('ar', { hour: '2-digit', minute: '2-digit' })}
          </Typography>
        );
      },
    },
    {
      field: 'status',
      headerName: 'الحالة',
      minWidth: 120,
      render: (value: any) => {
        const cfg = STATUS_CONFIG[value] || { label: value, color: 'default' as const };
        return <Chip component="span" size="small" label={cfg.label} color={cfg.color} variant="outlined" />;
      },
    },
    {
      field: 'notes',
      headerName: 'ملاحظات',
      minWidth: 180,
      render: (value: any) => (
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'pre-wrap' }}>
          {value || '—'}
        </Typography>
      ),
    },
  ], []);

  if (!userProfile?.uid) return null;

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      {/* @ts-ignore */}
      <MicrospecDataTable
        collection="appointments"
        title={{ type: 'Literal', text: 'المواعيد السابقة' } as any}
        subtitle={{ type: 'Literal', text: 'المواعيد المكتملة أو الملغية' } as any}
        columns={columns as any}
        wheres={[{ field: 'owner_id', value: userProfile.uid }]}
        onDataLoad={(data: any[]) => data.filter((row: any) => row.status === 'completed' || row.status === 'cancelled')}
        searchable
        refreshable
        emptyMessage="لا توجد مواعيد سابقة"
        pageSize={10}
      />
    </Container>
  );
};

export default PastAppointments;
